import clsx from 'clsx';

import './AppliedFilterChipPanel.css';
import { AppliedFilterChipType } from 'util/filter';
import { noop } from 'util/function';
import Chip from 'components/chip/Chip';
import Tooltip from 'components/tooltip/Tooltip';

//
// --- Types ---

export interface AppliedFilterChipPanelProps {
  className?: string;
  appliedFilterChips?: ReadonlyArray<AppliedFilterChipType>;
  onAppliedFilterChipDelete?: (filterChip: AppliedFilterChipType) => void;
}

//
// --- Constants ---

const PARTIAL_CATEGORY_TOOLTIP_MESSAGE = 'Not all items in this category are selected.';

//
// --- AppliedFilterChipPanel Component ---

/**
 * Display's material ui chips for filters that have been applied to a search
 */
const AppliedFilterChipPanel: React.FC<AppliedFilterChipPanelProps> = props => {
  const { className, appliedFilterChips = [], onAppliedFilterChipDelete = noop } = props;

  const hasAppliedFilterChips = Array.isArray(appliedFilterChips) && appliedFilterChips.length > 0;

  if (!hasAppliedFilterChips) {
    return null;
  }
  return (
    <div className={clsx('applied-filter-chip-panel', className)} data-testid="applied-filter-chip-panel">
      <div className="applied-filter-chip-panel-label">Filter by:</div>
      <div className="applied-filter-chip-panel-chip-container">
        {appliedFilterChips.map(appliedFilter => {
          const isPartialChildrenSelection = !appliedFilter.allChildrenChecked && appliedFilter.someChildrenChecked;

          // NOTE: when wrapped by Tooltip, the chips title gets set to the tooltip content
          // manual set aria-label so correct label is used
          const chipLabel = `${appliedFilter.chipLabel ? appliedFilter.chipLabel : appliedFilter.name}${
            isPartialChildrenSelection ? ' *' : ''
          }`;
          const chip = (
            <Chip
              aria-label={chipLabel}
              color="secondary"
              key={`applied-filter-chip-panel-chip-${appliedFilter.id}`}
              label={chipLabel}
              onDelete={() => onAppliedFilterChipDelete(appliedFilter)}
              size="small"
            />
          );

          const tooltipTitle = isPartialChildrenSelection ? PARTIAL_CATEGORY_TOOLTIP_MESSAGE : appliedFilter.tooltip;

          return tooltipTitle ? (
            <Tooltip key={`applied-filter-chip-panel-tooltip-chip-${appliedFilter.id}`} title={tooltipTitle}>
              {chip}
            </Tooltip>
          ) : (
            chip
          );
        })}
      </div>
    </div>
  );
};

export default AppliedFilterChipPanel;
